import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { openRewardModal } from 'dispatcher/modalDispatcher';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import { getRewardRequest } from 'entity/reward/rewardRedux';
import { RewardFilter } from 'entity/reward/rewardTypes';
import CreditHistoryModal from 'components/reward/CreditHistoryModal';
import DailyCheckInCard from 'components/reward/DailyCheckInCard';
import clsx from 'clsx';
import RewardCreditCard from './RewardCreditCard';
import RewardList from './RewardList';
import RewardDetailModal from './RewardDetailModal';

const RewardsContent = () => {
  const [selectedTab, setSelectedTab] = useState<RewardFilter>('browse-reward');

  const dispatch = useDispatch();
  const router = useRouter();

  const FILTER_VALUES: { title: string; value: RewardFilter }[] = [
    {
      title: 'Browse Rewards',
      value: 'browse-reward',
    },
    {
      title: 'My Rewards',
      value: 'my-reward',
    },
  ];

  // fetch reward if there is id
  useEffect(() => {
    const rewardId = router.query.id;
    if (rewardId) {
      dispatch(
        getRewardRequest({
          rewardId: Number(rewardId),
          onSuccess: () => dispatch(openRewardModal(Number(rewardId))),
        }),
      );
    }
  }, [router]);

  return (
    <div className="flex flex-col w-full pt-0 lg:pt-6 lg:w-[866px]">
      <div className="flex flex-col gap-3 w-full">
        <RewardCreditCard />
        <DailyCheckInCard />
        <div className="p-4 bg-white rounded h-fit">
          <div className="flex gap-5">
            {FILTER_VALUES.map(filter => {
              const isSelected = filter.value === selectedTab;
              return (
                <span
                  key={filter.title}
                  className={clsx(
                    'text-sm font-bold cursor-pointer',
                    isSelected ? 'text-blue-500' : 'text-neutral-500',
                  )}
                  onClick={() => {
                    setSelectedTab(filter.value);
                    const param = filter.value.split('-').join('_');
                    mixpanel.track(trackedEvents.RewardsCollection, {
                      param,
                    });
                  }}
                  data-testid={`${filter.value}-filter-button`}
                >
                  {filter.title}
                </span>
              );
            })}
          </div>
        </div>
        <RewardList rewardTabFilter={selectedTab} />
      </div>
      <CreditHistoryModal />
      <RewardDetailModal setSelectedTab={setSelectedTab} />
    </div>
  );
};

export default RewardsContent;
